import { Map, List } from 'immutable';
import { utils } from '@saucelabs/sl-module-performance';

import * as constants from '../types';
import { prepareURLItemFromJobInfo } from '../../../utils';

const initialState = new Map({
  jobData: new Map(),
  urlList: new List(),
  loadingJobData: true,
  jobInfo: new Map(),
});

const jobMetricsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.GET_JOB_DATA.REQUEST: {
      return state.withMutations((newState) => {
        newState
          .set('jobData', new Map())
          .set('urlList', new List())
          .set('loadingJobData', true);
      });
    }
    case constants.GET_JOB_DATA.SUCCESS: {
      return state.withMutations((newState) => {
        const urlList = [];
        const { items } = payload;
        items.forEach((jobInfo) => {
          const { order_index: orderIndex } = jobInfo;
          urlList.push(prepareURLItemFromJobInfo(jobInfo));
          newState.setIn(['jobData', orderIndex], jobInfo);
        });
        newState
          .set('urlList', List.of(...urlList))
          .set('loadingJobData', false);
      });
    }
    case constants.GET_JOB_DATA.FAILURE:
      return state.set('loadingJobData', false);
    case constants.UPDATE.SELECTED_TEST_PAGE_INFO:
      return state.set('jobInfo', utils.getSelectedJobMetrics(state.getIn(['jobData', payload])));
    case constants.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default jobMetricsReducer;
export { initialState };
